import * as React from "react";
import { Route, Switch } from "react-router-dom";
import Summary from "./Settlements.BankSettlements.Summary";
import List from "./Settlements.BankSettlements.List";

const BankSettlements = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/settlements/bank_settlements"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/settlements/bank_settlements/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default BankSettlements;
